import Category from '@/models/Category';
import { action } from 'typesafe-actions';
import { OnboardTypes } from './types';

export const completeOnboardRequest = (category: Category[]) => action(OnboardTypes.COMPLETE_ONBOARD_REQUEST, category);
export const completeOnboardSuccess = () => action(OnboardTypes.COMPLETE_ONBOARD_SUCCESS);
export const completeOnboardFailure = () => action(OnboardTypes.COMPLETE_ONBOARD_FAILURE);
